import {ValidationStatus, ValidationType} from './types';
import {SequencedFlowItem} from '@ael/core-api';

export class SequenceFlowValidator {
  public static isValid(item: SequencedFlowItem) {
    return this.validate(item).length === 0;
  }
  public static validate(item: SequencedFlowItem): ValidationStatus[] {
    const validations = [];

    if (item.contentItems.isEmpty()) {
      validations.push({
        type: ValidationType.Error,
        message: item.isMandatory
          ? 'Linear flow is marked as mandatory but has no items. This will prevent the users from ever completing this course.'
          : 'Linear flow has no items.',
        item,
        itemName: item.title ?? 'Unknown title', // This is always known! as there is a default in every Item
      });
    }

    return validations;
  }
}
